import Accordion from './accordion';
import HoverHandler from './hover-handler';
import MobileMenu from "./mobile-menu";
import ScrollHandler from "./scroll-handler";
import Search from './search';
import Toggles from "./toggles";
import {domReady} from './dom';
import lazySizes from 'lazysizes';

lazySizes.cfg.expand = 700;
lazySizes.cfg.init = false;

export const hoverHandler = new HoverHandler(
    [
        '.link',
        'a',
        '.button',
        'post-preview:not(.detailed)',
        'input[type="submit"]',
        'button[type="submit"]',
        '.accordion .label',
        '.indicator-nav .bullet',
        '.slide-next, .slide-prev',
        '.menu.level-1 > .item',
        '.post-preview.person',
        '#back-to-top'
    ]
);

let init = () => {
    let headerBreakpoint = 1099;
    let mobileHeaderHeight = 60;

    if(document.querySelector('.header-info-bar') !== null){
        mobileHeaderHeight += 35;
    }

    new MobileMenu(headerBreakpoint, '.header-navigation', mobileHeaderHeight);
    new Accordion({
        selectors: '.accordion .label',
    });

    if (typeof picturefill !== 'undefined') {
        picturefill();
    }

    new Toggles([
        {
            selector: '.post-preview.person',
            triggers: ['mousedown'],
            addClass: '-show-info',
            breakpoint: 700
        },
        {
            selector: '.post-preview.person',
            triggers: ['mouseenter'],
            addClass: '-show-info',
            breakpoint: 700
        },
        {
            selector: '.post-preview.person',
            triggers: ['mouseenter', 'mousedown'],
            affectedOthers: '.post-preview.person',
            removeClass: '-show-info',
            breakpoint: 700
        },
        {
            selector: '.cross-reference.person',
            triggers: ['mouseleave'],
            affectedOthers: '.post-preview.person',
            removeClass: '-show-info',
            breakpoint: 700
        },
        {
            selector: '.contact-banner',
            triggers: ['click'],
            toggleClass: '-open',
            breakpoint: 760
        },
    ]);

    new Search(headerBreakpoint, '.search-container');
    
    if(document.querySelector('#booking') === false ) { 
        new ScrollHandler('.back-to-top', 200);
    }

    forceMinimumHeight();
    window.addEventListener('resize', () => forceMinimumHeight());

    if(document.querySelector('[data-slider]') === null){
        lazySizes.init();
    }
};

domReady(init);

function forceMinimumHeight() {
    let viewport = window.innerHeight;
    let main = document.querySelector('.site-main');
    let footer = document.querySelector('.site-footer');
    let adminbar = document.getElementById('wpadminbar');

    if (!footer || !main) {
        return;
    }

    let minMainHeight = viewport - footer.getBoundingClientRect().height;
    if (adminbar !== null) {
        let adminbarStyle = window.getComputedStyle(adminbar);

        if (adminbarStyle.display !== 'none') {
            minMainHeight -= 32;
        }
    }

    if (main.getBoundingClientRect().height >= minMainHeight) {
        return;
    }

    main.style.minHeight = minMainHeight + 'px';
}
